export default {
    afterLoad(pluginHandler) {
        if( ! pluginHandler.isLoaded('ActionColumn')) {
            pluginHandler.load(['ActionColumn'])
        }
        if( ! pluginHandler.isLoaded('NotSet')) {
            pluginHandler.load(['NotSet'])
        }
        if( ! pluginHandler.isLoaded('Pagination')) {
            pluginHandler.load(['Pagination'])
        }
        if( ! pluginHandler.isLoaded('Sort')) {
            pluginHandler.load(['Sort'])
        }
        if( ! pluginHandler.isLoaded('Filters')) {
            pluginHandler.load(['Filters'])
        }
        if( ! pluginHandler.isLoaded('ColumnHints')) {
            pluginHandler.load(['ColumnHints'])
        }
    },
    mixins() {
        return {
            props: {
                displayActionColumn: {
                    type: Boolean,
                    default: true
                }
            },
            data() {
                return {
                    conditionsState: {}
                }
            },
            created() {
                this.internalTableClasses.push('oc-grid-view')

                // auto trigger the first change event on created
                setTimeout(() => {
                    this.$emit('change-internal', this.conditionsState)
                }, 1)
            },
            methods: {
                _insertActionsColumn() {
                    let found = false

                    for (let column of this.columns) {
                        if( column.type === 'ActionColumn' ) {
                            found = true
                        }
                    }

                    if( ! found && this.displayActionColumn ) {
                        this.columns.push(
                            this.formatColumn({title: "Actions", type: "ActionColumn", filterButton: true, filterResetButton: true})
                        )

                        return true
                    }

                    return false
                }
            },
            mounted() {
                this._insertActionsColumn()
            },
            beforeUpdate() {
                if(this._insertActionsColumn()) {
                    this.$forceUpdate()
                }
            }
        }
    }
}
